import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useCallback, useState } from "react";

export const EditableText: React.FC<{
  text: string;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  canEdit: boolean;
  className?: string;
  component?: "input" | "textarea";
}> = ({ text, onChange, canEdit, className, component = "input" }) => {
  const [focused, setFocused] = useState(false);

  const refCallback = useCallback(
    (element: HTMLInputElement | HTMLTextAreaElement | null) => {
      if (element && focused) {
        element.focus();
      }
    },
    [focused],
  );

  let thisClass = `focus-visible:ring-1 focus-visible:outline-none border-none text-ellipsis ${
    className || ""
  }`;
  if (!canEdit) {
    thisClass +=
      " cursor-not-allowed pointer-events-none bg-gray-100 text-gray-500";
  }

  if (focused) {
    const Component = component === "textarea" ? Textarea : Input;
    return (
      <Component
        ref={refCallback}
        disabled={!canEdit}
        value={text}
        onChange={onChange}
        className={thisClass}
        onBlur={() => setFocused(false)}
      />
    );
  } else {
    return (
      <div className={thisClass} onClick={() => canEdit && setFocused(true)}>
        {text
          .toString()
          .split("\n")
          .map((line, index) => (
            <p key={index}>
              {line}
              <br />
            </p>
          ))}
      </div>
    );
  }
};
